import React, { useEffect } from 'react';
import { FiCheck, FiChevronRight, FiBarChart2, FiAward, FiZap, FiShield, FiLayers, FiTrendingUp } from 'react-icons/fi';
import { FaSearchengin, FaShopify } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import BlurText from "../../animated/BlurText";
import logo from '../../images/logo.png'
import { TbSeo } from "react-icons/tb";

// Initialize AOS
const initAOS = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);
};

// // Navbar Component
// const Navbar = () => {
//   initAOS();
  
//   return (
//     <nav className="bg-white shadow-sm py-4 px-6 lg:px-12">
//       <div className="max-w-7xl mx-auto flex justify-between items-center">
//         <div className="flex items-center space-x-2">
//             {/* <img src={logo} width={100} alt="" /> */}
//             <FaSearchengin className="text-rich_black-500 text-4xl" />
//             <span className="text-4xl  font-bold bg-gradient-to-r from-fixify-darkBg to-dark_cyan-500 bg-clip-text text-transparent">
//                 Fixify
//             </span>
//         </div>
        
//         <div className="hidden md:flex space-x-8">
//           <a href="#features" className="text-gray-600 hover:text-teal-500 hover:underline transition-all">Features</a>
//           <a href="#pricing" className="text-gray-600 hover:text-teal-500 hover:underline transition-all">Pricing</a>
//           <a href="#testimonials" className="text-gray-600 hover:text-teal-500 hover:underline transition-all">Success Stories</a>
//           <a href="#contact" className="text-gray-600 hover:text-teal-500 hover:underline transition-all">Contact</a>
//         </div>
        
//         <div className="flex items-center space-x-4">
//           <a href="/login" className="text-gray-600 hover:text-teal-500 transition">Sign In</a>
//           <a 
//             href="/register" 
//             className="bg-gradient-to-r from-fixify-darkBg to-dark_cyan-500 text-vanilla-500 px-4 py-2 rounded-md hover:opacity-90 transition shadow-md"
//           >
//             Get Started
//           </a>
//         </div>
//       </div>
//     </nav>
//   );
// };

// Hero Section
const HeroSection = () => {
  return (
    <>

        <section className="pt-24 relative bg-gradient-to-r from-fixify-lightBg to-fixify-border pb-20 px-6 h-screen overflow-hidden">
            <span className='absolute motion-safe:animate-spin-slow opacity-65 -z-1 top-24 -left-40 w-96 h-96 rounded-full blur-2xl shadow-lg shadow-emerald-400 bg-gradient-to-br  from-blue-900 via-purple-950 from-20% to-teal-400  '></span>
            <span className='absolute motion-safe:animate-spin-slow  opacity-65 -z-1 top-0 -right-40 w-96 h-96 rounded-full blur-2xl shadow-lg shadow-dark_cyan-100 bg-gradient-to-br  from-blue-800 via-purple-400 from-20%  to-cyan-300 '></span>
            <span className='absolute motion-safe:animate-bounce-slow opacity-65 -z-1 bottom-0 -ml-36 w-96 h-96 rounded-full blur-2xl  shadow-lg shadow-emerald-400  bg-gradient-to-br  from-teal-800   to-teal-500 '></span>
            <div className="max-w-full min-h-full px-5 mx-auto bg-transparent backdrop-blur-md shadow-xl rounded-xl   grid md:grid-cols-2 gap-12 items-center">
                <div data-aos="fade-up">
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-800 leading-tight mb-6">
                    <BlurText
                        text="Automated SEO Fixes for "
                        delay={350}
                        animateBy="words"
                        direction="top"
                        // onAnimationComplete={handleAnimationComplete}
                        className="text-5xl font-extrabold w-full mb-8"
                    /> 
                    </h1>
                    <p data-aos="slide-right" className="h-20 bg-gradient-to-r from-fixify-darkBg to-dark_cyan-500 flex justify-start  bg-clip-text w-fit z-10 text-transparent text-4xl md:text-5xl font-bold my-14">Shopify stores</p>
                    <p className="text-xl font-semibold leading-10 bg-gradient-to-r from-gray-900 from-30% via-gray-700 to-gray-800 bg-clip-text text-transparent mb-8">
                    Boost your rankings with AI-powered SEO audits and 1-click fixes for meta tags, alt text, and broken links.
                    </p>
                    <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                    <a 
                        data-aos="fade-up"
                        href="/register" 
                        className="bg-gradient-to-r from-fixify-darkBg to-dark_cyan-500 text-vanilla-500 px-6 py-3 rounded-md hover:opacity-90 transition shadow-lg text-center font-medium"
                    >
                        Start Free Trial
                    </a>
                    <a 
                        data-aos="fade-up"
                        href="#demo" 
                        className="border border-blue-800 hover:border-rust-700 text-blue-800 hover:text-vanilla-500 px-6 py-3 rounded-md hover:bg-dark_cyan-400 transition transform duration-300 text-center font-medium"
                    >
                        Watch Demo
                    </a>
                    </div>
                </div>
                
                <div data-aos="fade-left" className="relative">
                    <div className="bg-white p-6 rounded-xl shadow-xl border border-gray-100">
                    <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center space-x-2">
                        <div className="w-3 h-3 rounded-full bg-red-500"></div>
                        <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                        <div className="w-3 h-3 rounded-full bg-green-500"></div>
                        </div>
                        <span className="text-xs text-gray-500">SEO Audit Dashboard</span>
                    </div>
                    
                    <div className="bg-gray-50 rounded-lg p-4 mb-4">
                        <div className="flex justify-between items-center mb-2">
                        <span className="font-medium">SEO Health Score</span>
                        <span className="text-teal-600 font-bold">78/100</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2.5">
                        <div className="bg-gradient-to-r from-fixify-darkBg to-dark_cyan-500 h-2.5 rounded-full" style={{width: '78%'}}></div>
                        </div>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <div className="bg-white border border-gray-200 rounded-lg p-3">
                        <div className="text-blue-800 font-bold text-xl mb-1">24</div>
                        <div className="text-xs text-gray-500">Issues Found</div>
                        </div>
                        <div className="bg-white border border-gray-200 rounded-lg p-3">
                        <div className="text-teal-600 font-bold text-xl mb-1">18</div>
                        <div className="text-xs text-gray-500">Auto-Fixable</div>
                        </div>
                    </div>
                    
                    <div className="space-y-3">
                        <div className="flex items-center justify-between">
                        <span className="text-sm">Missing Meta Titles</span>
                        <span className="text-red-500 text-sm font-medium">High</span>
                        </div>
                        <div className="flex items-center justify-between">
                        <span className="text-sm">Duplicate Content</span>
                        <span className="text-yellow-500 text-sm font-medium">Medium</span>
                        </div>
                        <div className="flex items-center justify-between">
                        <span className="text-sm">Missing Alt Text</span>
                        <span className="text-blue-500 text-sm font-medium">Low</span>
                        </div>
                    </div>
                    
                    <button className="w-full mt-4 bg-gradient-to-r from-fixify-darkBg to-dark_cyan-500 text-vanilla-500 py-2 rounded-md text-sm font-medium hover:opacity-90 transition">
                        Fix All Issues Now
                    </button>
                    </div>
                </div>
            </div>
        </section>
    </>
  );
};

// Stats Section
const StatsSection = () => {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div data-aos="fade-up" data-aos-delay="100" className="text-center">
            <div className="text-4xl font-bold text-blue-800 mb-2">95%</div>
            <div className="text-gray-600">Higher Visibility</div>
          </div>
          <div data-aos="fade-up" data-aos-delay="200" className="text-center">
            <div className="text-4xl font-bold text-teal-500 mb-2">10x</div>
            <div className="text-gray-600">More Organic Traffic</div>
          </div>
          <div data-aos="fade-up" data-aos-delay="300" className="text-center">
            <div className="text-4xl font-bold text-blue-800 mb-2">500+</div>
            <div className="text-gray-600">Stores Optimized</div>
          </div>
          <div data-aos="fade-up" data-aos-delay="400" className="text-center">
            <div className="text-4xl font-bold text-teal-500 mb-2">4.9/5</div>
            <div className="text-gray-600">Customer Rating</div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Features Section
const FeaturesSection = () => {
  const features = [
    {
      icon: <FiZap className="text-2xl text-teal-500" />,
      title: "Instant SEO Audit",
      description: "Get comprehensive SEO analysis in seconds with no manual work required."
    },
    {
      icon: <FiBarChart2 className="text-2xl text-blue-800" />,
      title: "Competitor Analysis",
      description: "Discover keyword gaps between you and top-ranking competitors."
    },
    {
      icon: <FiAward className="text-2xl text-teal-500" />,
      title: "AI-Powered Fixes",
      description: "Automatically generate and apply optimized meta tags and alt text."
    },
    {
      icon: <FiShield className="text-2xl text-blue-800" />,
      title: "Broken Link Detection",
      description: "Find and fix broken links that hurt your rankings and user experience."
    },
    {
      icon: <FiLayers className="text-2xl text-teal-500" />,
      title: "Weekly Auto-Scans",
      description: "Continuous monitoring with scheduled SEO health checks."
    },
    {
      icon: <FiTrendingUp className="text-2xl text-blue-800" />,
      title: "Ranking Reports",
      description: "Track your progress with detailed performance analytics."
    }
  ];
  
  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Powerful Features Built for Shopify</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Everything you need to dominate search rankings without the technical hassle.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index} 
              data-aos="fade-up" 
              data-aos-delay={(index % 3) * 100}
              className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition border border-gray-100"
            >
              <div className="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
        <hr />
        <hr />
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 py-16 px-4 sm:px-6 lg:px-8 rounded-2xl shadow-xl border border-gray-200">
          <div className="max-w-4xl mx-auto text-center">
            {/* Header */}
            <div className="mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                <span className="bg-gradient-to-r from-blue-600 to-teal-500 text-transparent bg-clip-text">
                  AI-Powered SEO Optimization
                </span>
                <br />
                Effortless, Precise, Results-Driven
              </h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                Generate and refine SEO elements with machine learning precision—faster than manual optimization.
              </p>
            </div>
        
            {/* Features Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
              {/* Feature 1 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start">
                <div className="bg-blue-100 p-3 rounded-lg mr-4">
                  <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-2">Smart Title & Meta Rewriting</h3>
                  <p className="text-gray-600">Automatically generates high-CTR titles and descriptions that rank better.</p>
                </div>
              </div>
        
              {/* Feature 2 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start">
                <div className="bg-purple-100 p-3 rounded-lg mr-4">
                  <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-2">Image Alt Text Optimization</h3>
                  <p className="text-gray-600">Creates descriptive, keyword-rich alt text that boosts accessibility and SEO.</p>
                </div>
              </div>
        
              {/* Feature 3 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start">
                <div className="bg-green-100 p-3 rounded-lg mr-4">
                  <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-2">Content Type Classification</h3>
                  <p className="text-gray-600">Identifies product/blog/service content to apply tailored optimization strategies.</p>
                </div>
              </div>
        
              {/* Feature 4 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start">
                <div className="bg-yellow-100 p-3 rounded-lg mr-4">
                  <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-2">Entity Extraction</h3>
                  <p className="text-gray-600">Detects brands, products, and key terms to naturally enrich your content.</p>
                </div>
              </div>
        
              {/* Feature 5 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start">
                <div className="bg-red-100 p-3 rounded-lg mr-4">
                  <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-2">Structured Data Generation</h3>
                  <p className="text-gray-600">Auto-creates JSON-LD markup to enhance how your pages appear in search results.</p>
                </div>
              </div>
        
              {/* Feature 6 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start">
                <div className="bg-indigo-100 p-3 rounded-lg mr-4">
                  <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-2">Search Intent Matching</h3>
                  <p className="text-gray-600">Aligns content with what searchers actually want for higher relevance.</p>
                </div>
              </div>
            </div>
        
            {/* Trust Signals */}
            <div className="flex flex-wrap justify-center gap-6 mb-12">
              <div className="flex items-center">
                <div className="flex-shrink-0 bg-green-100 p-1 rounded-full mr-2">
                  <svg className="h-5 w-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="text-gray-700 font-medium">Used by top eCommerce marketers</span>
              </div>
              <div className="flex items-center">
                <div className="flex-shrink-0 bg-green-100 p-1 rounded-full mr-2">
                  <svg className="h-5 w-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="text-gray-700 font-medium">Fine-tuned on real-world data</span>
              </div>
              <div className="flex items-center">
                <div className="flex-shrink-0 bg-green-100 p-1 rounded-full mr-2">
                  <svg className="h-5 w-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="text-gray-700 font-medium">Built with Google best practices</span>
              </div>
            </div>
        
            {/* CTA */}
            <button className="bg-gradient-to-r from-blue-600 to-teal-500 hover:from-blue-700 hover:to-teal-600 text-white font-semibold py-3 px-8 rounded-lg shadow-md transition-all duration-300 transform hover:scale-105">
              Start Optimizing Now →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

// Dashboard Preview Section
const DashboardPreview = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div data-aos="fade-right">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Actionable Insights at a Glance</h2>
            <p className="text-lg text-gray-600 mb-8">
              Our intuitive dashboard highlights exactly what needs fixing, prioritized by impact on your rankings.
            </p>
            
            <ul className="space-y-4">
              <li className="flex items-start">
                <FiCheck className="text-teal-500 mt-1 mr-3 flex-shrink-0" />
                <span className="text-gray-700">Visual issue breakdown by priority level</span>
              </li>
              <li className="flex items-start">
                <FiCheck className="text-teal-500 mt-1 mr-3 flex-shrink-0" />
                <span className="text-gray-700">Side-by-side competitor comparison</span>
              </li>
              <li className="flex items-start">
                <FiCheck className="text-teal-500 mt-1 mr-3 flex-shrink-0" />
                <span className="text-gray-700">Historical SEO score tracking</span>
              </li>
            </ul>
            
            <a 
              href="/register" 
              className="inline-flex items-center mt-8 text-blue-800 font-medium hover:text-teal-500 transition"
            >
              Explore Dashboard <FiChevronRight className="ml-1" />
            </a>
          </div>
          
          <div data-aos="fade-left" className="relative">
            <div className="bg-gradient-to-br from-fixify-darkBg to-dark_cyan-500 p-1 rounded-xl shadow-2xl">
              <div className="bg-white rounded-lg overflow-hidden">
                <div className="bg-gray-800 p-3 flex items-center justify-between">
                  <div className="flex space-x-2">
                    <div className="w-3 h-3 rounded-full bg-red-500"></div>
                    <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                    <div className="w-3 h-3 rounded-full bg-green-500"></div>
                  </div>
                  <div className="text-xs text-gray-300">SEOAutoFix Dashboard</div>
                  <div className="w-6"></div>
                </div>
                
                <div className="p-4">
                  <div className="flex justify-between items-center mb-6">
                    <div>
                      <div className="text-xs text-gray-500">Current Score</div>
                      <div className="text-2xl font-bold text-gray-800">78/100</div>
                    </div>
                    <div className="bg-blue-50 text-blue-800 px-3 py-1 rounded-full text-sm">
                      +12% Last Month
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-3 gap-4 mb-6">
                    <div className="bg-red-50 p-3 rounded-lg text-center">
                      <div className="text-red-600 font-bold text-xl">8</div>
                      <div className="text-xs text-gray-600">Critical</div>
                    </div>
                    <div className="bg-yellow-50 p-3 rounded-lg text-center">
                      <div className="text-yellow-600 font-bold text-xl">12</div>
                      <div className="text-xs text-gray-600">Warnings</div>
                    </div>
                    <div className="bg-green-50 p-3 rounded-lg text-center">
                      <div className="text-green-600 font-bold text-xl">42</div>
                      <div className="text-xs text-gray-600">Optimized</div>
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <div>
                      <div className="flex justify-between text-sm mb-1">
                        <span>Meta Tags</span>
                        <span className="font-medium">5 issues</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div className="bg-red-500 h-2 rounded-full" style={{width: '65%'}}></div>
                      </div>
                    </div>
                    
                    <div>
                      <div className="flex justify-between text-sm mb-1">
                        <span>Alt Text</span>
                        <span className="font-medium">7 issues</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div className="bg-yellow-500 h-2 rounded-full" style={{width: '35%'}}></div>
                      </div>
                    </div>
                    
                    <div>
                      <div className="flex justify-between text-sm mb-1">
                        <span>Broken Links</span>
                        <span className="font-medium">2 issues</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div className="bg-blue-500 h-2 rounded-full" style={{width: '15%'}}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Pricing Section
const PricingSection = () => {
  const plans = [
    {
      name: "Starter",
      price: "$29",
      period: "per month",
      description: "Perfect for small Shopify stores",
      features: [
        "Weekly SEO audits",
        "50 auto-fixes/month",
        "Basic competitor analysis",
        "Email support"
      ],
      cta: "Start Free Trial",
      popular: false
    },
    {
      name: "Pro",
      price: "$99",
      period: "per month",
      description: "For growing eCommerce brands",
      features: [
        "Daily SEO audits",
        "Unlimited auto-fixes",
        "Advanced competitor analysis",
        "Agency dashboard",
        "Priority support"
      ],
      cta: "Get Started",
      popular: true
    },
    {
      name: "Enterprise",
      price: "Custom",
      period: "",
      description: "For agencies & large stores",
      features: [
        "Real-time monitoring",
        "10+ store management",
        "White-label reports",
        "Dedicated account manager",
        "API access"
      ],
      cta: "Contact Sales",
      popular: false
    }
  ];
  
  return (
    <section id="pricing" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Simple, Transparent Pricing</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Start small and upgrade as your store grows. No hidden fees.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {plans.map((plan, index) => (
            <div 
              key={index} 
              data-aos="fade-up" 
              data-aos-delay={index * 100}
              className={`bg-white rounded-xl shadow-sm hover:shadow-md transition overflow-hidden ${plan.popular ? 'border-2 border-teal-500 relative' : 'border border-gray-100'}`}
            >
              {plan.popular && (
                <div className="bg-teal-500 text-white text-sm font-medium py-1 text-center">
                  Most Popular
                </div>
              )}
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-800 mb-1">{plan.name}</h3>
                <div className="flex items-end mb-4">
                  <span className="text-4xl font-bold text-gray-800">{plan.price}</span>
                  {plan.period && <span className="text-gray-600 ml-2">{plan.period}</span>}
                </div>
                <p className="text-gray-600 mb-6">{plan.description}</p>
                
                <ul className="space-y-3 mb-8">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="flex items-start">
                      <FiCheck className="text-teal-500 mt-1 mr-3 flex-shrink-0" />
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <a 
                  href={plan.name === 'Enterprise' ? '#contact' : '/register'} 
                  className={`block text-center py-3 px-6 rounded-md font-medium transition ${
                    plan.popular 
                      ? 'bg-gradient-to-r from-fixify-darkBg to-dark_cyan-500 text-vanilla-500 hover:opacity-90 shadow-md' 
                      : 'border border-dark_cyan-500 text-fixify-darkBg hover:bg-blue-50'
                  }`}
                >
                  {plan.cta}
                </a>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12" data-aos="fade-up">
          <p className="text-gray-600 mb-4">Need a one-time audit instead?</p>
          <a 
            href="#contact" 
            className="inline-flex items-center bg-gradient-to-r from-fixify-darkBg to-dark_cyan-500 text-clip text-transparent bg-clip-text font-medium transition-all"
          >
            Get a One-Time Audit for $99 <FiChevronRight className="ml-1" />
          </a>
        </div>
      </div>
    </section>
  );
};

// Testimonials Section
const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "Founder, LuxeBoutique",
      content: "SEOAutoFix helped us increase organic traffic by 230% in just 3 months. The automated fixes saved us countless hours of manual work.",
      rating: 5
    },
    {
      name: "Michael Chen",
      role: "SEO Director, EcomAgency",
      content: "Our clients love the competitor gap reports. It's become our secret weapon for outperforming competitors in search rankings.",
      rating: 5
    },
    {
      name: "David Rodriguez",
      role: "Owner, GadgetHub",
      content: "As a solo entrepreneur, I don't have time for complex SEO. This app does everything automatically and the results speak for themselves.",
      rating: 4
    }
  ];
  
  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Trusted by Shopify Store Owners</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join thousands of merchants who boosted their rankings with SEOAutoFix.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              data-aos="fade-up" 
              data-aos-delay={index * 100}
              className="bg-gray-50 p-8 rounded-xl border border-gray-200"
            >
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <svg
                    key={i}
                    className={`w-5 h-5 ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
              <p className="text-gray-700 mb-6 italic">"{testimonial.content}"</p>
              <div>
                <div className="font-medium text-gray-800">{testimonial.name}</div>
                <div className="text-sm text-gray-600">{testimonial.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// CTA Section
const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-fixify-darkBg to-dark_cyan-500">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <div data-aos="fade-up">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Ready to Boost Your Shopify SEO?</h2>
          <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
            Join thousands of stores increasing their organic traffic with automated SEO fixes.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <a 
              href="/register" 
              className="bg-white  px-8 py-4 rounded-md hover:bg-gray-100 transition shadow-lg text-lg font-medium"
            >
              <span className='bg-gradient-to-r from-fixify-darkBg to-dark_cyan-500 text-clip bg-clip-text text-transparent w-fit'>
                Start 3-Day Free Trial
              </span>
            </a>
            <a 
              href="#demo" 
              className="border border-white text-white px-8 py-4 rounded-md hover:bg-gradient-to-r hover:from-fixify-darkBg hover:to-dark_cyan-500 hover:text-vanilla-500 transition text-lg font-medium"
            >
              Watch Product Demo
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-400 py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <FaShopify className="text-teal-500 text-2xl" />
              <span className="text-xl font-bold text-white">SEOAutoFix</span>
            </div>
            <p className="text-sm">
              The easiest way to automate SEO for your Shopify store and dominate search rankings.
            </p>
          </div>
          
          <div>
            <h3 className="text-white font-medium mb-4">Product</h3>
            <ul className="space-y-2">
              <li><a href="#features" className="hover:text-teal-400 transition">Features</a></li>
              <li><a href="#pricing" className="hover:text-teal-400 transition">Pricing</a></li>
              <li><a href="#demo" className="hover:text-teal-400 transition">Demo</a></li>
              <li><a href="/login" className="hover:text-teal-400 transition">Login</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-medium mb-4">Resources</h3>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-teal-400 transition">Blog</a></li>
              <li><a href="#" className="hover:text-teal-400 transition">Help Center</a></li>
              <li><a href="#" className="hover:text-teal-400 transition">API Docs</a></li>
              <li><a href="#" className="hover:text-teal-400 transition">Status</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-medium mb-4">Company</h3>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-teal-400 transition">About Us</a></li>
              <li><a href="#" className="hover:text-teal-400 transition">Careers</a></li>
              <li><a href="#" className="hover:text-teal-400 transition">Privacy</a></li>
              <li><a href="#" className="hover:text-teal-400 transition">Terms</a></li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-gray-800 text-sm text-center">
          © {new Date().getFullYear()} SEOAutoFix. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

// Login Page
const Login = () => {
  initAOS();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-teal-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div data-aos="fade-up" className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
          <div className="p-8">
            <div className="flex justify-center mb-8">
              <div className="flex items-center space-x-2">
                <FaShopify className="text-teal-500 text-3xl" />
                <span className="text-2xl font-bold bg-gradient-to-r from-blue-800 to-teal-500 bg-clip-text text-transparent">
                  SEOAutoFix
                </span>
              </div>
            </div>
            
            <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">Welcome Back</h2>
            
            <form className="space-y-6">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input
                  type="email"
                  id="email"
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  placeholder="your@email.com"
                />
              </div>
              
              <div>
                <div className="flex justify-between items-center mb-1">
                  <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                  <a href="#" className="text-sm text-blue-600 hover:text-blue-800">Forgot password?</a>
                </div>
                <input
                  type="password"
                  id="password"
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  placeholder="••••••••"
                />
              </div>
              
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-blue-800 to-teal-500 text-white py-3 rounded-lg font-medium hover:opacity-90 transition shadow-md"
              >
                Sign In
              </button>
            </form>
            
            <div className="mt-6 text-center">
              <p className="text-gray-600">
                Don't have an account?{' '}
                <a href="/register" className="text-blue-600 hover:text-blue-800 font-medium">Sign up</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Register Page
const Register = () => {
  initAOS();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-teal-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div data-aos="fade-up" className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
          <div className="p-8">
            <div className="flex justify-center mb-8">
              <div className="flex items-center space-x-2">
                <FaShopify className="text-teal-500 text-3xl" />
                <span className="text-2xl font-bold bg-gradient-to-r from-blue-800 to-teal-500 bg-clip-text text-transparent">
                  SEOAutoFix
                </span>
              </div>
            </div>
            
            <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">Create Your Account</h2>
            
            <form className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                  <input
                    type="text"
                    id="firstName"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                    placeholder="John"
                  />
                </div>
                <div>
                  <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                  <input
                    type="text"
                    id="lastName"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                    placeholder="Doe"
                  />
                </div>
              </div>
              
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input
                  type="email"
                  id="email"
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  placeholder="your@email.com"
                />
              </div>
              
              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                <input
                  type="password"
                  id="password"
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  placeholder="••••••••"
                />
              </div>
              
              <div>
                <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1">Confirm Password</label>
                <input
                  type="password"
                  id="confirmPassword"
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  placeholder="••••••••"
                />
              </div>
              
              <div>
                <label htmlFor="storeName" className="block text-sm font-medium text-gray-700 mb-1">Shopify Store URL</label>
                <div className="flex">
                  <span className="inline-flex items-center px-3 rounded-l-lg border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
                    https://
                  </span>
                  <input
                    type="text"
                    id="storeName"
                    className="flex-1 min-w-0 block w-full px-4 py-3 rounded-r-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                    placeholder="yourstore.myshopify.com"
                  />
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="flex items-center h-5">
                  <input
                    id="terms"
                    type="checkbox"
                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                </div>
                <label htmlFor="terms" className="ml-2 block text-sm text-gray-700">
                  I agree to the <a href="#" className="text-blue-600 hover:text-blue-800">Terms of Service</a> and{' '}
                  <a href="#" className="text-blue-600 hover:text-blue-800">Privacy Policy</a>
                </label>
              </div>
              
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-blue-800 to-teal-500 text-white py-3 rounded-lg font-medium hover:opacity-90 transition shadow-md"
              >
                Create Account
              </button>
            </form>
            
            <div className="mt-6 text-center">
              <p className="text-gray-600">
                Already have an account?{' '}
                <a href="/login" className="text-blue-600 hover:text-blue-800 font-medium">Sign in</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Landing Page Component
const LandingPage = () => {
  initAOS();
  
  return (
    <div className="font-sans antialiased text-gray-800">
      <HeroSection />
      <StatsSection />
      <FeaturesSection />
      <DashboardPreview />
      <PricingSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export { LandingPage, Login, Register };